import { render, staticRenderFns, recyclableRender, components } from "./mall.vue?vue&type=template&id=2e142186&scoped=true&"
var renderjs
import script from "./mall.vue?vue&type=script&lang=js&"
export * from "./mall.vue?vue&type=script&lang=js&"
import style0 from "./mall.vue?vue&type=style&index=0&lang=css&"
import style1 from "./mall.vue?vue&type=style&index=1&id=2e142186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e142186",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mall/mall.vue"
export default component.exports